import { useTranslation } from 'react-i18next';
import { IoClose } from 'react-icons/io5';

const ACTIVE = 'flex-1 border border-secondary-800 text-secondary-800 bg-secondary-50 rounded-xl py-1 text-xs font-mono';
const INACTIVE = 'flex-1 border border-primary-50 text-primary-10 bg-background-600 rounded-xl py-1 text-xs font-mono';

const FilterToggle = ({ value, dateFrom, dateTo, onChange, onCustomClick, onClearDates }) => {
    const { t } = useTranslation();

    return (
        <>
            <div className="flex gap-2 mb-3">
                <button className={value === 'this_month' ? ACTIVE : INACTIVE}
                onClick={() => onChange('this_month')}>
                    {t('general.this_month')}
                </button>
                <button className={value === 'last_month' ? ACTIVE : INACTIVE}
                onClick={() => onChange('last_month')}>
                    {t('general.last_month')}
                </button>
                <button className={value === 'custom' ? ACTIVE : INACTIVE}
                onClick={onCustomClick}>
                    {t('general.custom')}
                </button>
            </div>
            {value === 'custom' && (dateFrom || dateTo) && (
                <div className="flex items-center justify-between bg-background-600 border border-secondary-800 rounded-xl px-3 py-2 mb-3">
                    <p className="text-secondary-800 text-xs font-mono">{dateFrom} - {dateTo}</p>
                    <button onClick={onClearDates}><IoClose className="text-primary-50 text-sm"/></button>
                </div>
            )}
        </>
    );
};

export default FilterToggle;